import { Directive, ElementRef, HostListener } from '@angular/core';
import { AbstractControl, NgControl } from '@angular/forms';

@Directive({
  selector: '[appFormatData]'
})
export class FormatDataDirective {
  public abstractControl: AbstractControl;

  constructor(private control: NgControl, private element: ElementRef) {
    element.nativeElement.maxLength = 10;
  }

  ngOnInit(): void {
    this.abstractControl = this.control.control;
  }

  @HostListener('keyup', ['$event.target.value'])
  inputChanged(value: string): void {
    const regex = /(\d{2})[-|/](\d{2})[-|/](\d{4})/g;
    if (regex.test(value) && value.length === 10) {
      const [year, month, day] = value.replace(regex, '$3-$2-$1').split('-');
      this.abstractControl.setValue(new Date(+year, +month - 1, +day));
    } else if (/\d{8}/g.test(value) && value.length === 8) {
      const [year, month, day] = value
        .replace(/(\d{2})(\d{2})(\d{4})/, '$3-$2-$1')
        .split('-');
      this.abstractControl.setValue(this.getCurrentDate(year, month, day));
    }
  }

  @HostListener('blur', ['$event.target.value'])
  inputBlur(value: string): void {
    const regex = /(\d{2})[-|/](\d{2})[-|/](\d{2})/g;
    const regexOnlyNumbers = /^\d+$/;
    const regexToSplitOnlyNumbers = /(\d{2})(\d{2})(\d{2})/;
    if (regex.test(value) && value.length === 8) {
      const [year, month, day] = value.replace(regex, '$3-$2-$1').split('-');
      this.abstractControl.setValue(this.getCurrentDate(year, month, day));
    } else if (regexOnlyNumbers.test(value) && value.length === 6) {
      const [year, month, day] = value
        .replace(regexToSplitOnlyNumbers, '$3-$2-$1')
        .split('-');
      this.abstractControl.setValue(this.getCurrentDate(year, month, day));
    }
  }

  getCurrentDate(year: string, month: string, day: string) {
    const currentYear = new Date().getFullYear();
    const yearNum = parseInt(year, 10);

    let fullYear: number;

    if (year.length === 4) {
      // Já é um ano completo (ex: 2025)
      fullYear = yearNum;
    } else {
      const currentCentury = Math.floor(currentYear / 100) * 100;
      fullYear = currentCentury + yearNum;

      if (fullYear - currentYear > 50) {
        fullYear -= 100;
      }
    }

    const fullMonth = parseInt(month, 10) - 1;
    const fullDay = parseInt(day, 10);

    return new Date(fullYear, fullMonth, fullDay);
  }
}
